<div class="ASM_hl-tkt-container">
    <div class="ASM_msg-one">
        Application Number
      </div>
      <div class="ASM_msg-two">
        Please enter your {{displayedExamName}} Application Number    
        </div>
    <div class="ASM_msg-three">
        *Enter your application number for a chance to win prizes of upto <span class="ASM_hl-tkt-prize">₹ 5 Lakhs.</span> For further information refer to <span class="ASM_hl-tkt-link" (click)="visit()">{{visitLink}}</span>
    </div>
    <div class="ASM_hl-tkt-field-box">
        <img class="ASM_hl-tkt-icon" src="assets/img/hall-ticket-icon.png" alt="" />
        <input class="ASM_hl-tkt-field" [(ngModel)]="hallTicket" placeholder="Application Number" />
    </div>
    <div class="ASM_invalid-ip" *ngIf="invalidInput">
        Please enter a valid Application Number
    </div>
    <div class="d-flex justify-content-between ASM_hl-tkt-submit-container">
        <div class="ASM_hl-tkt-submit" (click)="Submit()">SUBMIT</div>
  <div class="ASM_hl-tkt-skip" (click)="Close()">
      SKIP
  </div>
    </div>
  
</div>
  
    
    
 
